export const timeFormats = [
  { value: '24h', label: '24-hour', example: '14:30' },
  { value: '12h', label: '12-hour (AM/PM)', example: '2:30 PM' },
] as const;

export type TimeFormatValue = (typeof timeFormats)[number]['value'];
